import React from "react";
import PropTypes from "prop-types";
import styles from "./IntroduccioTitolClasse.module.css";

const IntroduccioTitolClasse = ({ titolClasse }) => {
  return <h2 className={styles.titol}>{titolClasse}</h2>;
};

IntroduccioTitolClasse.propTypes = {
  titolClasse: PropTypes.string.isRequired
};

export default IntroduccioTitolClasse;
